export default "__VITE_ASSET__DVPpoIpX__"